import LandingPage from "@/modules/landingPage";
import { createFileRoute } from "@tanstack/react-router";
import { queryClient } from "@/provider/PrivyProvider.tsx";
import { redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: LandingPage,
  beforeLoad: async () => {
    // Check if we're on deployed.dev with code in the query params
    const urlParams = new URLSearchParams(window.location.search);
    const codeParam = urlParams.get("code");
    queryClient.setQueryData(["REF_CODE_USER"], codeParam);

    // If we're on deployed.dev and have a REF code in the query params
    if (codeParam) {
      // Store the REF code in TanStack Query cache
      queryClient.setQueryData(["REF_CODE_USER"], codeParam);
      const refCodeUser = queryClient.getQueryData(["REF_CODE_USER"]);
      sessionStorage.setItem("REF_CODE_USER", refCodeUser as string);
      // clear all params
      const url = new URL(window.location.href);
      url.searchParams.delete("code");
      window.history.replaceState({}, document.title, url.toString());
      window.location.href = "/vault";
      redirect({
        to: "/vault",
        throw: true,
      });
      return;
    }

    // Handle the case for localhost URL with code parameter
    if (codeParam && codeParam.startsWith("REF-")) {
      // Store the code from URL parameter as REF_CODE_INVITE
      queryClient.setQueryData(["REF_CODE_INVITE"], codeParam);
      const refCodeInvite = queryClient.getQueryData(["REF_CODE_INVITE"]);
      redirect({
        to: "/vault",
        throw: true,
      });
      return;
    }
    redirect({
      to: "/vault",
      throw: true,
    });
    return {};
  },
});
